"use client";

import React from 'react';

export default function GlobalErrorLogger(): null {
  React.useEffect(() => {
    const onError = (ev: ErrorEvent) => {
      try {
        const info = {
          type: 'error',
          message: ev.message,
          filename: ev.filename,
          lineno: ev.lineno,
          colno: ev.colno,
          stack: ev.error?.stack ?? null,
          time: new Date().toISOString(),
        };
        // Keep a global reference for quick inspection in the console
        (window as any).__lastClientError = info;
        console.groupCollapsed('[GlobalErrorLogger] window.error', info.message);
        console.log(info);
        console.groupEnd();
      } catch (e) {
        // swallow
      }
    };

    const onRejection = (ev: PromiseRejectionEvent) => {
      try {
        const reason = ev.reason as any;
        const info = {
          type: 'unhandledrejection',
          message: typeof reason === 'string' ? reason : reason?.message ?? String(reason),
          stack: reason?.stack ?? null,
          time: new Date().toISOString(),
        };
        (window as any).__lastClientError = info;
        console.groupCollapsed('[GlobalErrorLogger] unhandledrejection', info.message);
        console.log(info);
        console.groupEnd();
      } catch (e) {
        // swallow
      }
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection as EventListener);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection as EventListener);
    };
  }, []);

  return null;
}
